import { Flex, Text } from "@simplybusiness/mobius";
import type { ReactNode } from "react";
import { Logo } from "../../QuoteCards/QuoteCard/Logo";

type ProductInfoProps = {
  logo: string;
  productTitle: string;
  premium?: string;
  policyStartDate?: string;
  children?: ReactNode;
};

export const ProductInfo = (props: ProductInfoProps) => {
  const { logo, productTitle, premium, policyStartDate, children } = props;

  return (
    <Flex flexDirection="column">
      <div className="mobius-payment-info__multi-product">
        <Logo logoPath={logo} className="mobius-payment-info__logo" />
        <Flex
          alignItems="baseline"
          gap="xs"
          justifyContent="space-between"
          className="mobius-payment-info__multi-product-text"
          flexGrow={1}
        >
          <strong>{productTitle}</strong>
          <strong>{premium}</strong>
        </Flex>
        <Text className="mobius-payment-info__start-date">
          Policy starting {policyStartDate}
        </Text>
        {children}
      </div>
    </Flex>
  );
};
